import { render, staticRenderFns } from "./popupChangePassword.vue?vue&type=template&id=f172ffde"
import script from "./popupChangePassword.vue?vue&type=script&lang=js"
export * from "./popupChangePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports